import type { UseQueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../api";
import { direktvermarktungApiWithoutCamelization } from "../../../api/subApis/direktvermarktungApi";
import type { FormulaVariablesResponse } from "../Direktvermarktung.types";

export function useDirektvermarktungFormulaAllowedVariables(
  options?: Partial<UseQueryOptions<FormulaVariablesResponse | undefined>>
) {
  const { data, isLoading, error } = useQuery({
    queryKey:
      direktvermarktungApiWithoutCamelization.formulaAllowedVariables.key(),
    queryFn: () => fetchDirektvermarktungFormulaAllowedVariables(),
    ...options
  });

  return {
    data,
    isLoading,
    error
  };
}

async function fetchDirektvermarktungFormulaAllowedVariables() {
  const direktvermarktungFormulaAllowedVariablesUrl =
    direktvermarktungApiWithoutCamelization.formulaAllowedVariables.url();
  const response = await apiWithoutCamelization.get<FormulaVariablesResponse>(
    direktvermarktungFormulaAllowedVariablesUrl
  );
  return response.data;
}
